import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'app-settings-stub-page',
  template: ` <div class="settings-stub-body">This page arrives in a later round.</div> `,
  styleUrl: './settings-stub-page.component.less',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SettingsStubPageComponent {}
